import {Directive, HostListener, HostBinding} from "@angular/core";
// solo para anclas
@Directive({
    selector: 'li[contar-clicks]'
})
/*
combinacion de HostBinding con el HostListener
*/
export class ContarClicksDirective{
    // cuenta los Clicks
    clickN = 0;
    @HostBinding('style.opacity') opacity: number=1;
    @HostListener('click', ['$event.target']) onClick(btn){
        console.log('a', btn, "Numero de clicks: ",this.clickN--);
        // incrementando la opacidad:
        this.opacity-=0.1;
    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/directives/contar-clicks.directive.ts